function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from "react";
import { IoMdLock } from "react-icons/io";
import { SDivider, SIcon } from "../components";
import SContextMenu from "../SContextMenu";
import { SInputV2 } from "../SInputV2";
import STooltip from "../Tooltip";
import { FuzzySearch } from "./FuzzySearch";
import { SimpleSearch } from "./SimpleSearch";
import { useEditorAPI } from "../Editor";
export const SVariablePicker = (_param)=>{
    var { items, didSelect, position, didClose, menuWidth = 375, asButton, render = undefined, enableHotkey = true, buttonRender = undefined, onAdd = undefined, addButtonRender = undefined, showCreateNew = false, headerRender } = _param, props = _object_without_properties(_param, [
        "items",
        "didSelect",
        "position",
        "didClose",
        "menuWidth",
        "asButton",
        "render",
        "enableHotkey",
        "buttonRender",
        "onAdd",
        "addButtonRender",
        "showCreateNew",
        "headerRender"
    ]);
    const [isOpen, setIsOpen] = useState(false);
    return /*#__PURE__*/ _jsx(SVariablePickerInner, _object_spread({
        items: items,
        didSelect: didSelect,
        didClose: didClose,
        menuWidth: menuWidth,
        asButton: asButton,
        position: position,
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        render: render,
        enableHotkey: enableHotkey,
        buttonRender: buttonRender,
        onAdd: onAdd,
        addButtonRender: addButtonRender,
        showCreateNew: showCreateNew,
        headerRender: headerRender
    }, props));
};
const SVariablePickerInner = ({ items, didSelect, didClose, menuWidth = 375, position, asButton, isOpen, setIsOpen, render = undefined, enableHotkey = true, buttonRender = undefined, addButtonRender = undefined, onAdd = undefined, direction = "right", disableFuzzySearch = false, showCreateNew = false, headerRender })=>{
    const { setHoveredNodeId } = useEditorAPI();
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [visibleCount, setVisibleCount] = useState(50);
    const selectedItemRef = useRef(null);
    const [item, setItem] = useState(undefined);
    const model = useMemo(()=>{
        // expensive to load everything so we just don't load it if it isn't open
        const d = buildDataModel(isOpen || !asButton ? items : []);
        if (item === undefined) {
            setItem(d.tree);
        } else {
            const findItem = (item, tree)=>{
                if (item.key === tree.key) {
                    return tree;
                } else if (tree.next) {
                    for (const next of tree.next){
                        const found = findItem(item, next);
                        if (found) {
                            return found;
                        }
                    }
                }
                return undefined;
            };
            const newItem = findItem(item, d.tree);
            if (newItem) {
                setItem(newItem);
            } else {
                setItem(d.tree);
            }
        }
        return d;
    }, [
        items,
        isOpen
    ]);
    const [searchValue, setSearchValue] = useState("");
    const inputRef = useRef(null);
    const searchResults = useMemo(()=>{
        setVisibleCount(50);
        if (searchValue.trim() === "") {
            return undefined;
        }
        const results = disableFuzzySearch ? model.simple.search(searchValue) : model.fuzzy.search(searchValue);
        console.log("[svp] results", results, disableFuzzySearch);
        return results;
    }, [
        items,
        searchValue
    ]);
    const itemList = useMemo(()=>{
        const items = searchResults || (item === null || item === void 0 ? void 0 : item.next) || [];
        // return items with next first and then items without next
        return items.sort((a, b)=>{
            if (a.next && b.next) {
                return 0;
            } else if (a.next) {
                return -1;
            } else if (b.next) {
                return 1;
            } else {
                return 0;
            }
        });
    }, [
        searchResults,
        item,
        items,
        model.tree
    ]);
    const onInputKeyDown = (e)=>{
        if (!asButton) {
            return;
        }
        const totalItems = (showCreateNew && itemList.length === 0 ? 1 : 0) + itemList.length;
        if (e.key === "ArrowDown") {
            e.preventDefault();
            setSelectedIndex((selectedIndex + 1) % totalItems);
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            setSelectedIndex((selectedIndex - 1 + totalItems) % totalItems);
        } else if (e.key === "ArrowLeft" || e.key === "Backspace" && searchValue === "" && (item === null || item === void 0 ? void 0 : item.parent)) {
            goBack();
        } else if (e.key === "Escape") {
            close();
            e.preventDefault();
            e.stopPropagation();
        } else if (e.key === "Enter" || e.key === "Tab" || e.key === "ArrowRight") {
            if (showCreateNew && itemList.length === 0 && selectedIndex === 0) {
                if (onAdd) {
                    onAdd({
                        setIsOpen
                    });
                }
            } else if (itemList && itemList.length > 0) {
                selectItem(itemList[selectedIndex]);
            }
        }
    };
    const close = ()=>{
        if (asButton) {
            setItem(model.tree);
            setIsOpen(false);
            didClose === null || didClose === void 0 ? void 0 : didClose();
        }
    };
    const selectItem = (item)=>{
        if (item.next && item.next.length > 0) {
            var _inputRef_current;
            setItem(item);
            setSearchValue("");
            (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
        } else {
            didSelect(item);
            close();
        }
    };
    const goBack = ()=>{
        setVisibleCount(50);
        if (item === null || item === void 0 ? void 0 : item.parent) {
            var _inputRef_current;
            setItem(item.parent);
            (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
        } else if (searchValue !== "") {
            var _inputRef_current1;
            setSearchValue("");
            (_inputRef_current1 = inputRef.current) === null || _inputRef_current1 === void 0 ? void 0 : _inputRef_current1.focus();
        } else {
        // close()
        }
    };
    const setOpen = (e)=>{
        if (asButton) {
            setIsOpen(e);
            if (e) {
                setSearchValue("");
                setSelectedIndex(-1);
            }
        }
    };
    useEffect(()=>{
        if (selectedItemRef.current) {
            selectedItemRef.current.scrollIntoView({
                behavior: "instant",
                block: "nearest",
                inline: "nearest"
            });
        }
    }, [
        selectedItemRef.current
    ]);
    useEffect(()=>{
        if (typeof window === "undefined") {
            return;
        }
        if (asButton) {
            if (isOpen && inputRef.current && document && inputRef.current !== document.activeElement) {
                inputRef.current.focus();
            }
        }
    }, [
        isOpen,
        asButton
    ]);
    const results = useMemo(()=>{
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsxs("div", {
                onScroll: (e)=>{
                    const didScrollToBottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
                    if (didScrollToBottom) {
                        setVisibleCount((prevCount)=>Math.min(prevCount + 10, itemList.length)) // Load 10 more items
                        ;
                    }
                },
                className: asButton ? `max-h-[400px] overflow-y-scroll ${position !== "fixed" ? "overscroll-none" : ""} relative` : "",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: `w-[100%] top-0 ${position !== "fixed" ? "bottom-[-1px]" : ""} left-0 absolute z-0 pointer-events-none`
                    }),
                    itemList.length === 0 ? showCreateNew ? /*#__PURE__*/ _jsx("div", {
                        onClick: ()=>{
                            if (onAdd) {
                                onAdd({
                                    setIsOpen
                                });
                            }
                        },
                        children: /*#__PURE__*/ _jsx("div", {
                            ref: (ref)=>{
                                if (selectedIndex === 0) {
                                    selectedItemRef.current = ref;
                                }
                            },
                            className: `grid grid-cols-[1fr,auto] items-center cursor-pointer px-3 py-2 transition-all ${asButton ? "hover:bg-grayscale-lighter/20 gap-2 " : ""} ${selectedIndex === 0 ? "!bg-grayscale-lighter/20" : ""}`,
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "grid grid-cols-[auto,1fr] items-center gap-3 truncate",
                                children: [
                                    addButtonRender ? /*#__PURE__*/ _jsx("div", {
                                        className: "flex ml-0.5 flex-row items-center w-[14px] h-[14px] justify-center text-white/50",
                                        onClick: ()=>{
                                            if (onAdd) {
                                                onAdd({
                                                    setIsOpen
                                                });
                                            }
                                        },
                                        children: addButtonRender({})
                                    }) : /*#__PURE__*/ _jsx(SIcon, {
                                        type: "plus",
                                        className: "text-white/50",
                                        size: 14
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "",
                                        children: /*#__PURE__*/ _jsxs("p", {
                                            className: "text-sm",
                                            children: [
                                                'Create new Parameter: "',
                                                searchValue,
                                                '"'
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }, `create-new-0`) : /*#__PURE__*/ _jsx("div", {
                        className: "text-white text-center p-4 flex flex-col items-center justify-center gap-3",
                        children: /*#__PURE__*/ _jsx("span", {
                            className: "text-sm opacity-50 ",
                            children: searchValue.trim() === "" ? "No variables found" : `No results for "${searchValue}"`
                        })
                    }) : null,
                    itemList.slice(0, visibleCount).map((item, index)=>{
                        var _item_state, _item_state1;
                        var _item_liquid;
                        return /*#__PURE__*/ _jsxs("div", {
                            onClick: ()=>!item.disabled && selectItem(item),
                            children: [
                                index != 0 && /*#__PURE__*/ _jsx(SDivider, {}),
                                /*#__PURE__*/ _jsx("div", {
                                    ref: (ref)=>{
                                        if (index === selectedIndex) {
                                            selectedItemRef.current = ref;
                                        }
                                    },
                                    onMouseEnter: ()=>{
                                        var _item_parent;
                                        if (((_item_parent = item.parent) === null || _item_parent === void 0 ? void 0 : _item_parent.key) === "element") {
                                            setHoveredNodeId(`node:${item.key}`);
                                        }
                                    },
                                    className: `grid grid-cols-[1fr,auto] items-center ${item.next || render === undefined ? "cursor-pointer" : ""} px-3 py-2 transition-all ${asButton ? "hover:bg-grayscale-lighter/20 gap-2 " : ""} ${selectedIndex == index ? "!bg-grayscale-lighter/20" : ""}`,
                                    children: render === undefined || item.next ? /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            item.body ? item.body : /*#__PURE__*/ _jsxs("div", {
                                                className: item.icon ? `grid grid-cols-[auto,1fr] items-center gap-2` : undefined,
                                                children: [
                                                    item.icon || undefined,
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("p", {
                                                                children: item.name
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "text-sm opacity-50 whitespace-wrap break-all",
                                                                children: !(item.next && item.next.length > 0) ? item.disabled || item.liquid : item.breadcrumbs || `${item.next.length} Value${item.next.length == 1 ? "" : "s"}`
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            item.accessory ? item.accessory : /*#__PURE__*/ _jsx("div", {
                                                className: "",
                                                children: item.next && item.next.length > 0 ? /*#__PURE__*/ _jsx(SIcon, {
                                                    className: "text-white/50",
                                                    size: 8,
                                                    type: "chevron-right-light"
                                                }) : /*#__PURE__*/ _jsx(STooltip, {
                                                    content: /*#__PURE__*/ _jsxs("div", {
                                                        className: "text-brand-primary text-sm",
                                                        children: [
                                                            item.value,
                                                            ((_item_state = item.state) === null || _item_state === void 0 ? void 0 : _item_state.locked) === true ? " | This value is read-only." : ""
                                                        ]
                                                    }),
                                                    placement: "top",
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        className: "text-brand-primary text-sm truncate max-w-[150px] flex flex-row",
                                                        children: [
                                                            item.value,
                                                            ((_item_state1 = item.state) === null || _item_state1 === void 0 ? void 0 : _item_state1.locked) === true ? /*#__PURE__*/ _jsx("span", {
                                                                className: "ml-2",
                                                                children: /*#__PURE__*/ _jsx(IoMdLock, {
                                                                    size: 16
                                                                })
                                                            }) : ""
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }) : render(item)
                                })
                            ]
                        }, `${(_item_liquid = item.liquid) !== null && _item_liquid !== void 0 ? _item_liquid : item.key}-${index}`);
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            height: "1px"
                        }
                    })
                ]
            })
        });
    }, [
        itemList,
        selectedIndex,
        asButton,
        render,
        visibleCount,
        showCreateNew
    ]);
    const input = useMemo(()=>{
        const inputProps = {
            value: searchValue,
            onChange: (e)=>{
                e.preventDefault();
                if (asButton) {
                    setSelectedIndex(0);
                }
                setItem(model.tree);
                setSearchValue(e.target.value);
            },
            onKeyDown: onInputKeyDown,
            ref: inputRef,
            goBack,
            item
        };
        if (headerRender) {
            return headerRender(_object_spread_props(_object_spread({}, inputProps), {
                onChange: inputProps.onChange
            }));
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: `${asButton ? "bg-grayscale-dark rounded-t-md" : ""} grid grid-cols-[auto,1fr,auto] gap-0  border-b border-white/10`,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "!px-3 border-r border-white/10 cursor-pointer text-brand-primary flex items-center justify-center w-[40px] h-[40px]",
                    onClick: goBack,
                    children: (item === null || item === void 0 ? void 0 : item.parent) ? /*#__PURE__*/ _jsx(SIcon, {
                        className: "rotate-180",
                        size: 13,
                        type: "chevron-right-light"
                    }) : /*#__PURE__*/ _jsx(SIcon, {
                        className: searchValue == "" ? "text-white/50" : "",
                        size: 12,
                        type: searchValue == "" ? "search" : "x"
                    })
                }),
                /*#__PURE__*/ _jsx(SInputV2, _object_spread_props(_object_spread({}, inputProps), {
                    autoFocus: true,
                    styleless: true,
                    className: `border-0 rounded-lg appearance-none w-full ring-0 focus:ring-0  w-full ring-0 !bg-grayscale-dark/0 outline-none focus:ring-0 focus:outline-none transition`,
                    placeholder: "Search"
                })),
                addButtonRender && /*#__PURE__*/ _jsx("div", {
                    className: "!px-3 border-l border-white/10 cursor-pointer text-brand-primary flex items-center justify-center w-[40px] h-[40px]",
                    onClick: ()=>{
                        if (onAdd) {
                            onAdd({
                                setIsOpen
                            });
                        }
                    },
                    children: addButtonRender({})
                })
            ]
        });
    }, [
        searchValue,
        asButton,
        model.tree,
        selectedIndex,
        itemList,
        headerRender
    ]);
    return asButton ? /*#__PURE__*/ _jsx(SContextMenu, {
        isOpen: isOpen,
        setIsOpen: setOpen,
        children: /*#__PURE__*/ _jsx(SContextMenu.Open, {
            isMinimal: true,
            menu: /*#__PURE__*/ _jsx(SContextMenu.Menu, {
                position: position,
                direction: direction,
                width: menuWidth,
                children: /*#__PURE__*/ _jsx(Items, {
                    asButton: true,
                    input: input,
                    item: item,
                    searchValue: searchValue,
                    goBack: goBack,
                    addButtonRender: addButtonRender,
                    onAdd: onAdd,
                    setIsOpen: setIsOpen,
                    children: results
                })
            }),
            className: `!h-[24px] !py-0 !pr-0`,
            hotkey: enableHotkey ? [
                "cmd",
                "i"
            ] : undefined,
            render: buttonRender,
            children: /*#__PURE__*/ _jsx("span", {
                children: "+ Add Variable"
            })
        })
    }) : /*#__PURE__*/ _jsx(Items, {
        input: input,
        item: item,
        searchValue: searchValue,
        goBack: goBack,
        addButtonRender: addButtonRender,
        onAdd: onAdd,
        setIsOpen: setIsOpen,
        children: results
    });
};
const Items = ({ input, item, asButton, children, searchValue, goBack, addButtonRender, onAdd, setIsOpen })=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: asButton ? " bg-grayscale-dark rounded-md shadow-xl border border-white/10" : "w-full",
        children: [
            input,
            children
        ]
    }, "SVariablePicker");
};
// Helper functions
const getBreadcrumbsForItem = (item)=>{
    return item.parent ? `${getBreadcrumbsForItem(item.parent)} > ${item.name}` : item.name;
};
const getLiquid = (item)=>{
    const getLiquidForItem = (item)=>{
        var _item_parent;
        let accessor = item.key;
        // if item.key has a space, it means it's a string and should be wrapped in quotes and brackts
        if (accessor.includes(" ")) {
            accessor = `["${accessor}"]`;
        } else {
            accessor = `.${accessor}`;
        }
        const result = item.parent ? `${getLiquidForItem(item.parent)}${accessor}` : item.key;
        return ((_item_parent = item.parent) === null || _item_parent === void 0 ? void 0 : _item_parent.key) === "element" ? result.replace("element.", "node.") : result;
    };
    return `{{ ${getLiquidForItem(item)} }}`;
};
const getId = (item)=>{
    const getIdForItem = (item)=>{
        return item.parent ? `${getIdForItem(item.parent)}.${item.key}` : item.key;
    };
    return `state:${getIdForItem(item)}`;
};
const buildTree = (data)=>{
    const tree = {
        key: "root",
        name: "root"
    };
    const buildInner = (data, parent)=>{
        return data.map((e)=>{
            const item = {
                key: e.key,
                name: e.name,
                value: e.value,
                disabled: e.disabled,
                parent: parent,
                icon: e.icon,
                state: e.state
            };
            if (parent) {
                item.liquid = getLiquid(item);
                item.breadcrumbs = getBreadcrumbsForItem(item);
            }
            if (e.next) {
                item.next = buildInner(e.next, item);
            } else {
                item.id = getId(item);
            }
            return item;
        });
    };
    const next = buildInner(data).map((e)=>{
        e.parent = tree;
        return e;
    });
    tree.next = next;
    return tree;
};
// converts the Item tree to a flat list
export const flattenTree = (data)=>{
    return data.reduce((acc, e)=>{
        return e.next ? [
            ...acc,
            e,
            ...flattenTree(e.next)
        ] : [
            ...acc,
            e
        ];
    }, []);
};
// fuzzy compare two strings. return a value between 0 and 1, where 1 means the strings are equal
const fuzzyCompare = (a, b)=>{
    const length = Math.max(a.length, b.length);
    const distance = Math.abs(a.length - b.length);
    const similarity = Math.min(a.length, b.length) / length;
    return similarity - distance / length;
};
const buildDataModel = (data)=>{
    const tree = buildTree(data);
    var _tree_next;
    const flat = flattenTree((_tree_next = tree.next) !== null && _tree_next !== void 0 ? _tree_next : []);
    const fuzzy = new FuzzySearch(flat, (item)=>{
        var _item_liquid;
        return (_item_liquid = item.liquid) !== null && _item_liquid !== void 0 ? _item_liquid : item.name;
    });
    const simple = new SimpleSearch(flat, (item)=>{
        var _item_liquid;
        return (_item_liquid = item.liquid) !== null && _item_liquid !== void 0 ? _item_liquid : item.name;
    });
    return {
        tree,
        fuzzy,
        simple
    };
};
